const base = '/api/public'

async function req(path, options = {}) {
  const res = await fetch(base + path, {
    headers: { 'Content-Type': 'application/json' },
    ...options,
  })
  if (!res.ok) {
    const corps = await res.json().catch(() => ({}))
    const detail = corps.detail
    // 503 avec un objet : la démarche existe mais elle est suspendue.
    if (res.status === 503 && detail && typeof detail === 'object') {
      const erreur = new Error(detail.message)
      erreur.indisponible = detail
      throw erreur
    }
    if (res.status === 422 && detail && typeof detail === 'object' && detail.champs) {
      // le serveur nomme les questions à corriger : le formulaire y ramène
      const erreur = new Error(detail.message)
      erreur.champs = detail.champs
      throw erreur
    }
    throw new Error(detail?.message || detail || "Le service ne répond pas")
  }
  return res.json()
}

export const api = {
  site: () => req('/site'),
  form: (slug) => req(`/forms/${slug}`),
  submit: (slug, payload) => req(`/forms/${slug}/submit`, { method: 'POST', body: JSON.stringify(payload) }),
  slots: (key) => req(`/agenda/${key}/slots`),
  follow: (number, code) => req(`/requests/${number}?code=${encodeURIComponent(code)}`),
  answer: (number, code, payload) =>
    req(`/requests/${number}/answer?code=${encodeURIComponent(code)}`, {
      method: 'POST', body: JSON.stringify(payload),
    }),
}
